import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from "react";
import { createRoot } from 'react-dom/client';
import "./index.css";
import App from "./App";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { createStore, combineReducers, applyMiddleware } from "redux";
import Thunk from "redux-thunk";
import { Provider } from "react-redux";
import { userReducer } from "./store/reducers/user";
import { appReducer } from "./store/reducers/app";
import { formsReducer } from "./store/reducers/forms";
import { policiesReducer } from "./store/reducers/policies";
import { claimsReducer } from "./store/reducers/claims";
import { driverightReducer } from './store/reducers/driveright';
import { esignatureReducer } from './store/reducers/esignature';
import { anonAutoFormReducer } from './store/reducers/anonAutoForm';
import { anonHomeFormReducer } from './store/reducers/anonHomeForm';
import { anonymousFormsReducer } from './store/reducers/anonymousForms';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { muiComponentsTheme } from './utilities/styleUtilities';

const rootReducer = combineReducers({
  app: appReducer,
  user: userReducer,
  forms: formsReducer,
  claims: claimsReducer,
  policies: policiesReducer,
  driveright: driverightReducer,
  esignature: esignatureReducer,
  anonAutoForm: anonAutoFormReducer,
  anonHomeForm: anonHomeFormReducer,
  anonymousForms: anonymousFormsReducer,
});

export const store = JSON.parse(sessionStorage.getItem("appState")) && !window.location.href.includes("?land=")
  ? createStore(rootReducer, JSON.parse(sessionStorage.getItem("appState")), applyMiddleware(Thunk))
  : createStore(rootReducer, applyMiddleware(Thunk));//populating the store from session storage if exists AND if not initial navigate into app with query params, to fix reload

const container = document.getElementById("root");
const root = createRoot(container);

const theme = createTheme(muiComponentsTheme);

root.render(
  <Provider store={store}>
      <Router basename='/claimsx-client'>
        <React.StrictMode>
          <ThemeProvider theme={theme}>
          <Route path="/" component={App} />
          </ThemeProvider>
        </React.StrictMode>
      </Router>
  </Provider>

);